var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-out"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2746 9.55806C16.5187 9.80214 16.5187 10.1979 16.2746 10.4419L13.7746 12.9419C13.5305 13.186 13.1348 13.186 12.8907 12.9419C12.6467 12.6979 12.6467 12.3021 12.8907 12.0581L14.3238 10.625H9.99935C9.65417 10.625 9.37435 10.3452 9.37435 10C9.37435 9.65482 9.65417 9.375 9.99935 9.375H14.3238L12.8907 7.94194C12.6467 7.69786 12.6467 7.30214 12.8907 7.05806C13.1348 6.81398 13.5305 6.81398 13.7746 7.05806L16.2746 9.55806Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83268 3.125C5.25739 3.125 4.79102 3.59137 4.79102 4.16667V15.8333C4.79102 16.4086 5.25739 16.875 5.83268 16.875H14.166C14.7413 16.875 15.2077 16.4086 15.2077 15.8333V15C15.2077 14.6548 15.4875 14.375 15.8327 14.375C16.1779 14.375 16.4577 14.6548 16.4577 15V15.8333C16.4577 17.099 15.4317 18.125 14.166 18.125H5.83268C4.56703 18.125 3.54102 17.099 3.54102 15.8333V4.16667C3.54102 2.90101 4.56703 1.875 5.83268 1.875H14.166C15.4317 1.875 16.4577 2.90101 16.4577 4.16667V5C16.4577 5.34518 16.1779 5.625 15.8327 5.625C15.4875 5.625 15.2077 5.34518 15.2077 5V4.16667C15.2077 3.59137 14.7413 3.125 14.166 3.125H5.83268Z",
    fill: "#9897A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.b0ef93ce01df7b30363292eb83606ed1.svg";
export { ForwardRef as ReactComponent };